import React from "react";
import { Route, Switch } from "react-router-dom";
import { Path } from "paths";
import { ReservationList } from "modules";
import { useMount } from "hooks";
import { setPageTitle } from "services";
import ReservationDetailsPage from "./reservation-details.page";

const ReservationPage = () => {
  useMount(() => {
    setPageTitle("reservations");
  });
  return (
    <Switch>
      <Route exact path={Path.RESERVATION_LIST} component={ReservationList} />
      <Route path={Path.RESERVATION_VIEW} component={ReservationDetailsPage} />
    </Switch>
  );
};

export default ReservationPage;
